import React from "react";

const Facebook = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M25.782 20l.876-5.791h-5.476V10.45c0-1.585.765-3.13 3.218-3.13h2.489v-4.93S24.629 2 22.469 2c-4.509 0-7.456 2.774-7.456 7.795v4.414H10V20h5.013v14h6.17V20h4.6z"
            fill={fill}
        />
    </svg>
);

export default Facebook;
